import { StorageSerializers, useSessionStorage } from '@vueuse/core'
import { SERVICE_RECORD } from '~/constants'

export function useServiceRecord() {
  return useSessionStorage<ServiceRecord | null>(SERVICE_RECORD, null, { flush: 'sync', serializer: StorageSerializers.object })
}
